import { Chip, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

const TOOLTIP =
  'Cohort matrix: rows are signup cohorts, columns are periods since signup. Incomplete periods may still change.';

const VARIANT_STYLES = {
  default: {
    label: 'Matrix',
    height: 20,
    fontSize: '0.6875rem',
    labelPx: 0.75,
  },
  /** Tight sidebar row — single line with truncated title. */
  compact: {
    label: 'Mx',
    height: 16,
    fontSize: '0.625rem',
    labelPx: 0.5,
  },
};

/**
 * Nav label for reports that use a signup-cohort × period grid (not calendar time series).
 */
export function CohortMatrixBadge({ size = 'small', variant = 'default', sx }) {
  const v = VARIANT_STYLES[variant] ?? VARIANT_STYLES.default;
  const height = variant === 'default' && size === 'medium' ? 24 : v.height;
  const fontSize = variant === 'default' && size === 'medium' ? '0.75rem' : v.fontSize;

  return (
    <Tooltip title={TOOLTIP} arrow placement='top'>
      <Chip
        component='span'
        label={v.label}
        size='small'
        variant='outlined'
        sx={{
          height,
          fontSize,
          fontWeight: 600,
          letterSpacing: '0.02em',
          flexShrink: 0,
          lineHeight: 1,
          verticalAlign: 'middle',
          borderColor: 'info.main',
          color: 'info.dark',
          bgcolor: (theme) =>
            theme.palette.mode === 'dark' ? `${theme.palette.info.main}18` : `${theme.palette.info.main}0c`,
          '& .MuiChip-label': { px: v.labelPx, py: 0 },
          ...sx,
        }}
      />
    </Tooltip>
  );
}

CohortMatrixBadge.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['default', 'compact']),
  sx: PropTypes.object,
};
